import React, { FC } from "react";
import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonContent,
    IonPage,
    IonText,
} from "@ionic/react";
import { HeaderComponent } from "../../../../components";
import { useTranslation } from "react-i18next";
import { useSubscription } from "../../../../components/hooks";
import refsixSquareLogo from "../../../../assets/images/icon/refsix-square-icon.png";
import knvbLogo from "../../../../assets/images/icon/knvb-logo-vector-2022.svg";

const KnvbIntegration: FC = () => {
    const { t } = useTranslation();

    const subscriptionState = useSubscription();

    const refAssistSubs = subscriptionState?.subscriptions?.filter((sub) => {
        return sub.provider === "refassist";
    });

    return (
        <IonPage>
            <HeaderComponent
                showBackButton
                defaultHref={"/"}
                title="KNVB"
                titleTestId="knvb-integrations-page-header"
            />
            <IonContent>
                <IonCard color="transparent">
                    <IonCardContent>
                        <div
                            style={{
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                            }}
                        >
                            <img
                                style={{ width: "64px" }}
                                src={refsixSquareLogo}
                                alt={"refsix logo"}
                            />
                            <IonText
                                style={{
                                    margin: "0 20px",
                                    fontSize: "30px",
                                    fontWeight: "700",
                                }}
                            >
                                +
                            </IonText>
                            <img
                                style={{
                                    width: "100px",
                                }}
                                src={knvbLogo}
                                alt={"KNVB logo"}
                            />
                        </div>
                    </IonCardContent>
                </IonCard>

                <IonCard style={{ color: "white", padding: 10 }}>
                    <IonCardContent>
                        <h2 style={{ marginBottom: 20 }}>
                            REFSIX werkt samen met de KNVB om te zorgen dat jouw
                            wedstrijden in de REFSIX-app verschijnen.
                        </h2>
                        <ol style={{ margin: 0, padding: 0 }}>
                            <li>
                                Klik op het plus icoontje in het midden van de
                                menubalk onderaan je scherm en selecteer
                                ‘KNVB-wedstrijd’
                            </li>
                            <li>
                                Vul het wedstrijdnummer in. Dat nummer vind je
                                in de voetbal.nl app of de Wedstrijdzaken app
                            </li>
                            <li>
                                Selecteer de wedstrijd en klik ’Wedstrijden
                                toevoegen’ om hem toe te voegen aan je
                                wedstrijdoverzicht
                            </li>
                        </ol>
                    </IonCardContent>
                </IonCard>

                <div className="youtube-full-width">
                    <iframe
                        width="1380"
                        height="776"
                        src="https://www.youtube.com/embed/ifU4qQdCNRE"
                        title="Hoe voeg je een KNVB-wedstrijd toe aan REFSIX?"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default KnvbIntegration;
